class SwiperConfigurator {
  static swiperInstances = new Map();

  constructor(sliderElement) {
    this.element = sliderElement;
    this.options = this.parseConfig();
    this.initializeSwiper();
  }

  parseConfig() {
    const { dataset: { swiper } } = this.element;

    try {
      return JSON.parse(swiper || "{}");
    } catch (error) {
      console.error("Error parsing slider configuration:", error);
      return {};
    }
  }

  async initializeSwiper() {
    if (!this.element || this.element.swiper) {
      return;
    }

    try {
      await window.loadSwiperAssets();

      if (this.element.swiper) {
        return;
      }

      const instance = new Swiper(this.element, this.options);
      SwiperConfigurator.swiperInstances.set(this.element, instance)
    } catch (error) {
      console.error('Failed to initialize Swiper:', error);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  (function () {
    const swipers = document.querySelectorAll('[data-swiper]');
    swipers.forEach(swiper => new SwiperConfigurator(swiper));
  })();

  setLeftMargin()
});

function setLeftMargin() {
  let wrapperHalf = document.querySelectorAll('[data-set-margin]');
  let currentMarginEl = document.querySelector('[data-wrapper]');

  if (wrapperHalf.length != 0 && currentMarginEl) {
    wrapperHalf.forEach(elem => {
      elem.style.marginLeft = `${currentMarginEl.offsetLeft}px`;
      elem.style.paddingLeft = `20px`;
      elem.style.paddingRight = `20px`;
    })
  }
}

window.addEventListener('resize', function () {
  setLeftMargin();
});



(function () {
  const featureImages = document.querySelectorAll('.feature-content img');

  function handleIntersection(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-on-scroll');
        observer.unobserve(entry.target);
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersection, {
    root: null,
    rootMargin: '0px',
    threshold: 0.5
  });

  featureImages.forEach(image => observer.observe(image));
})();


(() => {
  if (localStorage.getItem('first-visited-page') || !window.Shopify?.pageId) return

  localStorage.setItem('first-visited-page', window.Shopify.pageId);
})()
